import axios from '@/libs/api.request'

const rtcLogService = {
  log (data) {
    if (data.log && data.log instanceof Object) {
      data.log = JSON.stringify(data.log)
    }
    if (data.tags) {
      if (typeof data.tags === 'string') {
        data.tags = [data.tags]
      }
    }
    data.timestamp = new Date()
    return axios.request({
      url: '/rtc/log',
      method: 'POST',
      data: data
    })
  },
  error (log, appointmentId, tags) {
    return this.log({
      log: log,
      level: 'ERROR',
      tags: tags,
      appointmentId: appointmentId
    })
  },
  warn (log, appointmentId, tags) {
    return this.log({
      log: log,
      level: 'WARN',
      tags: tags,
      appointmentId: appointmentId
    })
  },
  info (log, appointmentId, tags) {
    return this.log({
      log: log,
      level: 'INFO',
      tags: tags,
      appointmentId: appointmentId
    })
  },
  debug (log, appointmentId, tags) {
    return this.log({
      log: log,
      level: 'DEBUG',
      tags: tags,
      appointmentId: appointmentId
    })
  }
}

export default rtcLogService
